import React, { useCallback } from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import GamePlayStore from './store';
import TopMenu from '@src/business-components/top-menu';
import styles from './index.less';
import CommonFooter from '@src/business-components/common-footer';

import toWebpImage from '@src/utils/to-webp-image';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import redirect from '@src/utils/redirect-if-mobile-accress';
// 移动端页面，如果是PC端访问，跳转到PC端页面
//redirect.redirectIfPc();
const lang = getLanguageByPath();

const GamePlay = ({ store }) => {
  store.use();
  const { layerData, expandPlay, activeIndex, initState } = store;

  const PlayType = ({ data, index, activeIndex, initState, onExpand = () => { } }) => {
    const { gameplay_num_img, gameplay_type, gameplay_cover, gameplay_title, gameplay_description } = data;
    const targetExpand = useCallback(() => onExpand(index), []);
    return (
      <div className={cx(styles.playTypeComponent, initState === -1 ? styles.pageInit : '', activeIndex === index ? styles.active : '')}>
        <div className={styles.layout1}>
          {/* 主体内容 */}
          <div className={styles.head} onClick={targetExpand}>
            <div className={styles.typeTitle}>
              <img className={styles.listNum} src={gameplay_num_img} alt={gameplay_type} />
              <div className={cx(styles.text, activeIndex === index && styles.text_active)}>{gameplay_type}</div>
            </div>
            <div data-index={index}>
              <div className={styles.detailBtn}>
                <img className={styles.checkIcon} src={toWebpImage(require('./images/check-ditail-icon.png'))} alt="查看详情" />
                <div className={styles.text}>{getLocales('game_play.text')}</div>
              </div>
              <div className={styles.arrowBottom} />
            </div>
          </div>
          <div className={styles.contentWrap}>
            <div className={styles.content}>
              <div className={styles.cover}>
                <img src={gameplay_cover} alt="" />
              </div>
              <div className={styles.dividingLine} />
              <div className={styles.contentText}>
                <div className={styles.subTitle}>{gameplay_title}</div>
                <div className={styles.text}>{gameplay_description}</div>
              </div>
            </div>
            <img alt="" src={toWebpImage(require('./images/content-dividingline.png'))} className={styles.footerLine} />
          </div>
        </div>

        {/* 2个装饰元素 */}
        <div className={styles.bg1} />

        {/* 右边叠加光影 */}
        <div className={cx(styles.bg2Group, activeIndex === index ? styles.bg2Group_active : '')}>
          <img className={cx(styles.item1)} src={toWebpImage(require('./images/title-border-bg4.png'))} alt="" />
          <img className={cx(styles.item2)} src={toWebpImage(require('./images/title-border-bg4.png'))} alt="" />
          <img className={cx(styles.item3)} src={toWebpImage(require('./images/title-border-bg4.png'))} alt="" />
        </div>

        {/* 渐变光效背景 */}
        <div className={styles.bg3Group}>
          <div className={styles.lightBg} />
          <div className={styles.expandLightBg} />
        </div>

        {/* 斜切框框 */}
        <div className={styles.bg4Group}>
          <div className={styles.bg4} />
        </div>

        {/* TODO:未知原因写在一个父组件里面，left的元素动画前一秒会固定在左上角，暂时这样处理 */}
        <div className={cx(styles.bg5)}>
          <img alt="" className={cx(styles.left)} src={toWebpImage(require('./images/expand-layout-1.png'))} />
        </div>

        <div className={cx(styles.bg5)}>
          <img alt="" className={cx(styles.right)} src={toWebpImage(require('./images/expand-layout-1.png'))} />
        </div>
      </div>
    );
  };

  return (
    <div className={cx(styles.root, 'page-main')}>
      <TopMenu />
      <div className={styles.pageTitle}>
        <img className={styles.pageTitleBg} src={toWebpImage(require('./images/' + store.Lang() + '/title.png'))} alt="INTRO" />
      </div>
      <div className={styles.playTypeList}>
        {layerData?.gameplay_list?.map((item, index) => (
          <PlayType key={index} initState={initState} onExpand={expandPlay} index={index} activeIndex={activeIndex} data={item} />
        ))}
      </div>
      <div className={styles.fotterBgGroup}>
        <div className={styles.bg} />
      </div>
      <div className={styles.lightBg} />
      {/* 底栏 */}
      <div className={styles.footerBox}>{<CommonFooter store={store.CommonFooterStore} />}</div>
    </div>
  );
};

export default wrapStore(GamePlay, GamePlayStore);
